/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetHistoryProgrammerToday } from "../../funcs/miscGetHistoryProgrammerToday.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$miscGetHistoryProgrammerToday: ToolDefinition = {
  name: "misc-get-history-programmer-today",
  description: `程序员历史上的今天

想知道程序员历史上的今天发生了什么大事吗？这个接口告诉你答案！

## 功能概述
我们使用AI智能筛选从海量历史事件中挑选出与程序员、计算机科学相关的重要事件。每个事件都经过重要性评分和相关性评分，确保内容质量。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await miscGetHistoryProgrammerToday(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
